import template from './cities.html';
import controller from './cities.controller';

let citiesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default citiesComponent;
